import React from 'react';
import { observer } from 'mobx-react';
import SubusersComponent from './Subusers.component';
import useSubusers from './useSubusers';

const Container = () => {
    const { subusers, devices, groups, lang, state, handlers } = useSubusers();

    return (
        <SubusersComponent
            loading={subusers.loading || groups.loading}
            lang={lang.lang}
            subusersDevices={subusers.subusersDevices}
            devices={devices.deviceList}
            subusersList={subusers.subusersList}
            addSubuserVisible={state.addSubuserVisible}
            editSubuserVisible={state.editSubuserVisible}
            deleteSubuserVisible={state.deleteSubuserVisible}
            subuserDevicesVisible={state.subuserDevicesVisible}
            addDeviceToSubuserVisible={state.addDeviceToSubuserVisible}
            editSubuserRightsVisible={state.editSubuserRightsVisible}
            deviceBtnHover={state.deviceBtnHover}
            deleteDeviceVisible={state.deleteDeviceVisible}
            visibleList={state.visibleList}
            onAddSubuserOpen={handlers.handleAddSubuserOpen}
            onAddSubuserClose={handlers.handleAddSubuserClose}
            onEditSubuserOpen={handlers.handleEditSubuserOpen}
            onEditSubuserClose={handlers.handleEditSubuserClose}
            onDeleteSubuserOpen={handlers.handleDeleteSubuserOpen}
            onDeleteSubuserClose={handlers.handleDeleteSubuserClose}
            onSubuserDevicesClose={handlers.handleSubuserDevicesClose}
            onAddDeviceToSubuserOpen={handlers.handleAddDeviceToSubuserOpen}
            onAddDeviceToSubuserClose={handlers.handleAddDeviceToSubuserClose}
            onEditSubuserRightsOpen={handlers.handleEditSubuserRightsOpen}
            onEditSubuserRightsClose={handlers.handleEditSubuserRightsClose}
            onDeviceBtnHoverStart={handlers.handleDeviceBtnHoverStart}
            onDeviceBtnHoverStop={handlers.handleDeviceBtnHoverStop}
            onDeleteDeviceOpen={handlers.handleDeleteDeviceOpen}
            onDeleteDeviceClose={handlers.handleDeleteDeviceClose}
            onSubuserClick={handlers.handleSubuserClick}
        />
    );
};

const SubusersContainer = observer(Container);

export default SubusersContainer;
